export default __webpack_public_path__ + "static/media/r2_c1.2432d0ea.jpg";